/** @format */

document.addEventListener("DOMContentLoaded", function () {
  // console.log("Loaded on policy page");
  const container = document.getElementsByClassName(
    "shopify-policy__container"
  );
  if (container) {
    container[0].style.visibility = "visible";

    // 控制 Osano 開 drawer
    const btns = document.querySelectorAll(".open-osano");
    btns.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        Osano.cm.showDrawer();
      });
    });
  }
});
